import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-img",
  "use": "icon-img-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-img\">\r\n<title>file_img</title>\r\n<path fill=\"#6c7afb\" d=\"M27.789 3.333h-23.579c-1.253 0-2.211 0.961-2.211 2.217v20.619c0 1.182 0.958 2.217 2.211 2.217h23.579c1.179 0 2.211-1.035 2.211-2.217v-20.619c0-1.182-0.958-2.217-2.211-2.217zM9.221 7.102c1.253 0 2.358 1.035 2.358 2.365s-1.032 2.365-2.358 2.365c-1.253 0-2.358-1.035-2.358-2.365s1.105-2.365 2.358-2.365zM7.526 25.060c-0.221 0-0.442-0.074-0.663-0.222-0.442-0.369-0.442-0.887-0.074-1.33l4.568-6.429c0.368-0.369 0.884-0.443 1.326-0.148l3.979 2.808 7.147-7.686c0.368-0.37 2.137-2.291 3.168-0.148v13.081c0 0.074-19.453 0.074-19.453 0.074z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/img.svg
// module id = HnV6
// module chunks = 14